import { Box, Grow } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

interface Props {
  children: React.ReactElement<unknown>;
  threshold?: number
  timeout?: number
}

export default function Observer(props: Props) {
  const ref = useRef() as any
  const [isView, setIsView] = useState(false)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsView(true)
        observer.disconnect()
      }
    });
  }, {
    rootMargin: '0px',
    threshold: props.threshold || 0.3
  })

  useEffect(() => {
    observer.observe(ref.current)
  })

  return (
    <Box ref={ref}>
      <Grow in={isView} {...(isView ? { timeout: props.timeout } : {})}>
        <Box>
          {props.children}
        </Box>
      </Grow>
    </Box>
  )
}